const ecomInterval = setInterval(() => {
  const modal = document.querySelector(".ecomsend__Modal__Container");
  if (modal) {
    const submitButton = document.querySelector(".ecomsend__Button");
    if (submitButton) {
      submitButton.addEventListener("click", function (event) {
        const email = modal.querySelector(
          '.ecomsend__Modal__Container input[type="email"]'
        ).value;
        const phone = modal.querySelector(
          '.ecomsend__Modal__Container input[type="tel"]'
        ).value;
        const cleanedPhone = phone.replace(/[\s-]/g, "");
        const checkConsent = modal.querySelector(
          '.ecomsend__Modal__Container input[name="checkbox"]'
        ).checked;

        const header_value = {
          isoLanguage: "EN",
          isoCountry: "IN",
          brandCode: "BH8702",
          campaignId: "PN002392",
          campaignDescription: "Always On",
          origin: "https://lovebeautyandplanet.in/",
          formType: "signUp",
          entity: "PRM2.6",
        };

        const x_api_key = "665fb793-eb8d-42ed-85e7-31981ee4ac1a";

        const consumerIdentity = {
          firstName: "N/A",
          lastName: "N/A",
        };

        const contactDetail = {
          email: email,
          mobileNumber: cleanedPhone,
        };

        const optInStatus = {
          legalAgeConsent: checkConsent,
          unileverEmailConsent: checkConsent,
          unileverSMSConsent: checkConsent,
        };

        const data_value = JSON.stringify({
          profile: {
            header: header_value,
            consumerIdentity,
            contactDetail,
            optInStatus,
          },
        });

        if (checkConsent == true) {
          fetch("https://forms-sg.unileversolutions.com/v3", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": x_api_key,
            },
            body: data_value,
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then((data) => {
              console.log("Success:", data);
              // If the API call is successful, submit the form to Shopify
            })
            .catch((error) => {
              console.error("Error:", error);
              // alert("Failed to submit the form. Please try again.");
            });
        }
      });
    }

    clearInterval(ecomInterval); // Stop checking once the modal is found
  }
}, 500); // Check every 500ms
